<div class="sdds-row bg-gray-50 pt-16 ">
    <div
        class="sdds-col-max-12 sdds-col-xxlg-12 sdds-col-xlg-12 sdds-col-lg-12 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12">
        <h2>Specifications</h2>
    </div>
    <div class="sdds-col-max-12 sdds-col-xxlg-12 sdds-col-xlg-12 sdds-col-lg-12 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12"
        [ngClass]="{'loading':loading}">
        <app-toolbar [addDataTargetEnabled]="false" addDataTarget="#createNewSpecificationModal"
            [collapseEnabled]="true" [dataTargetEnabledRemove]="false" [expandEnabled]="true"
            (collapseEventEmitter)="collapseTree();" (expandEventEmitter)="expandTree();"
            [addButtonText]="'Add specification'" [createSpecification]="true"
            [createButtonId]="'createNewSpecificationModal'" [filterEnabled]="true"
            (filterTextEventEmitter)="filter($event);" [isAllowed]="canCreateDeleteSpecification()"
            [extraButtonShow]="isUsEnvironment" [extraButtonText]="'Import From Global'"
            [extraButtonId]="'importFromGlobalModal'"
            [extraButtonDataTarget]="'#importFromGlobalModal'"></app-toolbar>

        <div class="usage-tabs">
                <button type="button"
                        class="usage-tab"
                        [class.active]="usageFilter === 'all'"
                        (click)="setUsage('all')">All</button>
                <button type="button"
                        class="usage-tab"
                        [class.active]="usageFilter === 'scomm'"
                        (click)="setUsage('scomm')">Scomm</button>
                <button type="button"
                        class="usage-tab"
                        [class.active]="usageFilter === 'jps'"
                        (click)="setUsage('jps')">Secure Update</button>
        </div>

        <div *ngIf="ecuFamilytree && ecuFamilytree.isEmpty">
            <p>The tree is empty. Add a new specification to proceed.</p>
        </div>

        <div class="overflow-y-auto sdds-no-padding h-screen">
            <ng-container *ngIf="ecuFamilytree && !ecuFamilytree.isEmpty">
                <app-tree [tree]="ecuFamilytree"></app-tree>
            </ng-container>
        </div>
    </div>
</div>

<app-create-new-specification (newSpecificationCreated)="onSpecificationCreated()"></app-create-new-specification>

<app-import-from-global *ngIf="isUsEnvironment" (specificationImported)="onSpecificationCreated()"></app-import-from-global>